/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outdatedbrowser_Safariupdateinstructions3Inputs */

const en_outdatedbrowser_safariupdateinstructions3 = /** @type {(inputs: Outdatedbrowser_Safariupdateinstructions3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Safari is bundled with macOS. Please update macOS to receive the latest Safari version.`)
};

/**
* | output |
* | --- |
* | "Safari is bundled with macOS. Please update macOS to receive the latest Safari version." |
*
* @param {Outdatedbrowser_Safariupdateinstructions3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const outdatedbrowser_safariupdateinstructions3 = /** @type {((inputs?: Outdatedbrowser_Safariupdateinstructions3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outdatedbrowser_Safariupdateinstructions3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_outdatedbrowser_safariupdateinstructions3(inputs)
});
export { outdatedbrowser_safariupdateinstructions3 as "outdatedBrowser_safariUpdateInstructions" }